import { call, put, select } from 'redux-saga/effects'
import { Action } from 'redux-actions'
import { fetchOrderList } from 'requests/order'

import { getDefaultFinishedOrdersPeriod, getPeriodFromUrl } from 'components/molecules/OrderListFilter/order-list-finished-period.utils'

import { addHttpError } from 'store/http-error/http-error.actions'
import { selectToken } from 'store/users/users.selectors'

import { FetchOrdersRequestPayload, fetchOrdersSuccess, fetchOrdersFailure } from '../orders.actions'
import {
  selectFinishedOrdersDateFrom,
  selectFinishedOrdersDateTo,
  selectOrderFilterId,
  selectOrdersPage,
  selectOrdersPageSize,
} from '../orders.selectors'

const resolvePeriod = (payload: string | FetchOrdersRequestPayload | void, finishedDateFrom: string, finishedDateTo: string) => {
  if (payload && typeof payload === 'object' && payload.period) {
    return payload.period
  }

  if (finishedDateFrom && finishedDateTo) {
    return { dateFrom: finishedDateFrom, dateTo: finishedDateTo }
  }

  const urlPeriod = getPeriodFromUrl()
  if (urlPeriod) {
    return urlPeriod
  }

  return getDefaultFinishedOrdersPeriod()
}

export function* fetchOrdersSaga(action: Action<string | FetchOrdersRequestPayload | void>) {
  try {
    const token = yield select(selectToken)
    const filter = yield select(selectOrderFilterId)
    const page = yield select(selectOrdersPage)
    const pageSize = yield select(selectOrdersPageSize)
    const finishedDateFrom = yield select(selectFinishedOrdersDateFrom)
    const finishedDateTo = yield select(selectFinishedOrdersDateTo)
    const period = resolvePeriod(action.payload, finishedDateFrom, finishedDateTo)

    const orders = yield call(fetchOrderList, token, {
      ...(filter ? { filter } : {}),
      sort: 'server',
      page,
      pageSize,
      dateFrom: period.dateFrom,
      dateTo: period.dateTo,
    })
    const payload = orders.response ?? orders

    yield put(
      fetchOrdersSuccess({
        ...payload,
        pagination: payload.pagination ?? orders.pagination,
      }),
    )
  } catch (error) {
    yield put(fetchOrdersFailure(error))
    yield put(
      addHttpError({
        error,
        header: 'Получение списка заявок',
        defaultText: 'Не удалось получить список заявок',
      }),
    )
    console.error(`[fetchOrdersSaga]: ${error}`)
  }
}
